/**
 * @desc  id 속성을 갖는 gradient 따위를 포함한 svg 들이있다.
 *        safari browser 에서 위와 같은 svg를 한 화면에 여러개 렌더시,
 *        gradient id가 중복되어 정상적으로 렌더를 못하는 이슈가 있다.
 *        이를 막기 위한 각 svg 마다 고유한 id 를 갖는 컴포넌트
 * */
const KorailLogoWithId = ({ height, width }) => {
  const id = Math.floor(Math.random() * 10000)

  return (
    <svg width={width} height={height} viewBox={`0 0 70 20`} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient
          cx="12.514%"
          cy="40.386%"
          fx="12.514%"
          fy="40.386%"
          r="85.168%"
          gradientTransform="matrix(.36535 0 0 1 .08 0)"
          id={`gradient-1-${id}`}
        >
          <stop stopColor="#00A2D9" offset="0%" />
          <stop stopColor="#00A2D9" offset="29.363%" />
          <stop stopColor="#005BAB" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="19.379%"
          cy="-11.394%"
          fx="19.379%"
          fy="-11.394%"
          r="128.184%"
          gradientTransform="matrix(.46726 0 0 1 .103 0)"
          id={`gradient-2-${id}`}
        >
          <stop stopColor="#00A2D9" offset="0%" />
          <stop stopColor="#00A2D9" offset="27.964%" />
          <stop stopColor="#005BAB" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M56.845 4.431c-.706 0-.997.253-1.147.905l-1.691 10.47h3.803l1.845-11.375h-2.81zM13.42 4.114h-3.293c-.505 0-.79.162-1.13.475l-3.76 3.66.908-4.135h-2.98c-.71 0-1.004.253-1.146.911L0 15.807h3.742l1.026-5.076 3.487 5.076h4.656L8.274 9.203l5.146-5.09zm50.906 9.03 1.5-8.713h-2.811c-.695 0-.99.243-1.136.868l-1.7 10.508h8.97l.344-2.663h-5.167z"
          fill="#005BAB"
        />
        <path
          d="M20.403.031a8.47 8.47 0 0 0-7.59 6.762c2.052-1.836 5.985-2.487 12.008-.428a42.68 42.68 0 0 1 3.736 1.474 35.913 35.913 0 0 1 3.195 1.653c2.268 1.305 4.801 3.121 6.853 5.315h5.55l3.792-7.72.02-.256 1.49 7.979h3.891L50.958 3.43h-3.593c-.563 0-.8.162-1.049.56l-4.683 9.27-3.338-3.019c1.51-.42 3.19-1.582 3.662-3.529.838-3.457-2.083-3.6-3.052-3.6h-5.361c-.693 0-.817.15-.962.78l-1.03 4.846c-2.628-1.71-8.598-5.183-12.793-5.24-1.06-.014-1.83.147-2.58.608-.11.068-.138.064-.157.06l.06-.123c.451-.555 1.377-1.44 2.928-1.923 0 0 2.483-.866 5.805 1.155a35.686 35.686 0 0 1 4.502 3.205C28.41 2.735 25.063 0 21.134 0c-.242 0-.485.01-.73.031m15.815 4.887h1.391s1.39-.083.895 1.795c0 0-.551 2.22-3.116 2.22.113-.57.745-3.608.83-4.015"
          fill={`url(#gradient-1-${id})`}
          transform="translate(0 1)"
        />
        <path
          d="M15.895 7.88s-1.941.893-2.064 3.098c-.13 2.142 1.503 3.627 1.503 3.627l.007.011a8.47 8.47 0 0 0 5.743 2.266h.063c.236-.001.474-.012.713-.032 3.839-.327 6.805-3.194 7.522-6.775.283.07.895.243 1.77.53l-.893 4.202h3.927s.316-1.653.62-2.963c-2.23-1.349-4.6-2.282-4.6-2.282-4.21-1.802-7.687-2.485-10.285-2.485-1.759 0-3.116.313-4.026.803"
          fill={`url(#gradient-2-${id})`}
          transform="translate(0 1)"
        />
      </g>
    </svg>
  )
}

export default KorailLogoWithId
